module.exports = __webpack_public_path__ + "static/media/bh.64fbbb84.svg";